import React, { useState, useEffect } from 'react';
import Login from './components/Login/Login';
import MenuScreen from './components/MenuScreen/MenuScreen';
import OptionsScreen from './components/OptionsScreen/OptionsScreen';
import VehiclePickup from './components/VehiclePickup/VehiclePickup';
import VehicleReturn from './components/VehicleReturn/VehicleReturn';
import GPSTracking from './components/GPSTracking/GPSTracking';
import GeodezijaAssetTracking from './components/GeodezijaAssetTracking/GeodezijaAssetTracking';

function App() {
  const [user, setUser] = useState(() => {
    try {
      const savedUser = localStorage.getItem('user_data');
      return savedUser ? JSON.parse(savedUser) : null;
    } catch (error) {
      console.error('Error parsing user data from localStorage:', error);
      localStorage.removeItem('user_data');
      localStorage.removeItem('auth_token');
      return null;
    }
  });
  const [currentScreen, setCurrentScreen] = useState('menu');
  const [menuDefaultGeodezijaOpen, setMenuDefaultGeodezijaOpen] = useState(false);

  const handleLogin = (userData) => {
    setUser(userData);
    setCurrentScreen('menu');
  };

  const handleLogout = () => {
    setUser(null);
    setCurrentScreen('menu');
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user_data');
  };

  const handleNavigate = (screen) => {
    // If user is navigating away from menu, reset auto-open flag.
    if (screen !== 'menu') {
      setMenuDefaultGeodezijaOpen(false);
    }
    setCurrentScreen(screen);
  };

  const backToGeodezijaMenu = () => {
    // Make "back" resilient even if state is lost/cached.
    localStorage.setItem('zzf_open_geodezija_menu', '1');
    setMenuDefaultGeodezijaOpen(true);
    setCurrentScreen('menu');
  };

  if (!user) {
    return <Login onLogin={handleLogin} />;
  }

  // Render different screens based on currentScreen state
  switch (currentScreen) {
    case 'menu':
      return <MenuScreen onNavigate={handleNavigate} user={user} defaultOpenGeodezijaMenu={menuDefaultGeodezijaOpen} />;
    case 'options':
      return <OptionsScreen onNavigate={handleNavigate} onBack={() => setCurrentScreen('menu')} />;
    case 'pickup':
      return <VehiclePickup onNavigate={handleNavigate} />;
    case 'return':
      return <VehicleReturn onBack={() => setCurrentScreen('options')} />;
    case 'gps-tracking':
      return <GPSTracking onBack={backToGeodezijaMenu} user={user} />;
    case 'skener-tracking':
      return <GeodezijaAssetTracking onBack={backToGeodezijaMenu} user={user} assetType="skener" />;
    case 'dron-tracking':
      return <GeodezijaAssetTracking onBack={backToGeodezijaMenu} user={user} assetType="dron" />;
    case 'nivelir-tracking':
      return <GeodezijaAssetTracking onBack={backToGeodezijaMenu} user={user} assetType="nivelir" />;
    case 'stanica-tracking':
      return <GeodezijaAssetTracking onBack={backToGeodezijaMenu} user={user} assetType="stanica" />;
    case 'tableti-tracking':
      return <GeodezijaAssetTracking onBack={backToGeodezijaMenu} user={user} assetType="tableti" />;
    default:
      return <MenuScreen onNavigate={handleNavigate} user={user} />;
  }
}

export default App;